namespace $.$$ {
	export class $shm_hitalama_map_widget_float_settings extends $.$shm_hitalama_map_widget_float_settings {

		controlled_settings_content() {
			const link = this.controlled_widget().link()
			return this.Map_page().Widget(link).Sub().settings_content()
		}

		controlled_type_name() {
			const type = this.controlled_widget().type()
			const title = $shm_hitalama_map_widget_def_titles[type] ?? type
			return title
		}

		controlled_title(): string {
			const w = this.controlled_widget()
			const title = w.title() === w.link_str()
				? this.controlled_type_name()
				: w.title()
			
			return title
		}

		controlled_copy_id() {
			return this.controlled_widget().link_str()
		}
		
		@ $mol_mem
		text( next?: string ): string {
			return this.controlled_widget().text( next ) ?? ''
		}
		
		@ $mol_mem
		code( next?: string ): string {

			// if(next) {
			// 	const chunks = splitStringByChunk(next)
			// 	chunks.forEach( t => {
			// 		const prev = this.controlled_widget().Text()?.value() ?? ''
					// this.controlled_widget().Text(next)?.value(next)
					// this.controlled_widget().Text(null)?.value(prev+t)
			// 	} )
			// }

			return this.controlled_widget().code( next ) ?? ''
		}

		controlled_title_click() {
			this.Map_page().go_to_widget( this.controlled_widget().link() )
		}

	}

	function splitStringByChunk(str: string, chunkSize: number = 1000): string[] {
		const chunks: string[] = [];
		
		for (let i = 0; i < str.length; i += chunkSize) {
			chunks.push(str.slice(i, i + chunkSize));
		}
		
		return chunks;
	}
}
